export default theme => ({
  root: {
    direction: 'rtl',
    paddingTop: 15,
    paddingLeft: 10,
    paddingRight: 10,
    letterSpacing: -0.3,
    color: '#fc4a38',
    marginRight: 20,
    listStyleType: 'disc',

    '& li': {
      marginBottom: 15
    }
  }
});